import {Component, OnInit, ViewChild} from '@angular/core';
import {EditorComponent} from '../../shared/editor/editor.component';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../api.service';
import {TagsComponent} from '../../tags/tags.component';
import {MessageTypes} from '../../message';
import {MessageService} from '../../message.service';

@Component({
    selector: 'app-edit-note',
    templateUrl: './edit-note.component.html',
    styleUrls: ['./edit-note.component.css']
})
export class EditNoteComponent implements OnInit {
    @ViewChild(EditorComponent) editor: EditorComponent;
    note: any;
    private id: any;
    state: string;
    submitLabel: string;
    @ViewChild(TagsComponent)
    protected tagsComponent: TagsComponent;

    constructor(protected route: ActivatedRoute, protected apiService: ApiService, protected messageService: MessageService) {
        this.note = {
            title: ''
        };
    }

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        this.state = '';
        if (id) {
            this.id = id;
            this.state = 'loading';
            this.submitLabel = 'update';
            this.loadNote();
        } else {
            this.submitLabel = 'save';
        }
    }

    loadNote() {
        this.submitLabel = 'loading';
        this.apiService.getById('notes', this.id).subscribe(
            (value) => {
                this.note = value;
                this.editor.setContent(value['text']);
                this.tagsComponent.tags = this.note.tags;
                this.state = '';
                this.submitLabel = 'update';
            }, (error) => {
                this.state = '';
                this.submitLabel = 'update';
            }
        );
    }

    submit() {
        const content = this.editor.getContent();
        console.log('save text:', content);
        this.note.tags = this.tagsComponent.tags;
        this.note.text = content;
        this.state = 'saving';
        this.submitLabel = 'saving';
        if (this.id) {
            this.apiService.put('notes', this.id, this.note)
                .subscribe(
                    (value: any) => {
                        this.messageService.setMessage('Note got updated', MessageTypes.Success);
                        this.state = '';
                        this.submitLabel = 'update';
                    }, (err) => {
                        this.messageService.setMessage('An error occurred - the note didn`t get updated', MessageTypes.Error);
                        this.state = '';
                        this.submitLabel = 'update';
                    });
        } else {
            this.apiService.post('notes', this.note)
                .subscribe(
                    (value: any) => {
                        this.messageService.setMessage('Note added', MessageTypes.Success);
                        this.state = '';
                        this.submitLabel = 'save';
                    }, (err) => {
                        this.messageService.setMessage('Failed to save note', MessageTypes.Error);
                        this.state = '';
                        this.submitLabel = 'save';
                    }
                );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/notes/edit-note/edit-note.component.ts